<template>
    <div class="login-container">
      <div class="logo-container">
        <!-- 在这里插入你的Logo图像 -->
        <img src='@/assets/8aa2ead5-7b06-4d4d-b913-60dec3a6e88e.jpg' alt="Logo" />
      </div>
      <form @submit.prevent="onSubmit">
        <div class="form-group">
          <label for="username">用户名:</label>
          <input type="text" id="username" v-model="loginForm.username" required>
        </div>
        <div class="form-group">
          <label for="password">密码:</label>
          <input type="password" id="password" v-model="loginForm.password" required>
        </div>
        <div class="button-container">
          <button type="submit">登录</button>
        </div>
      </form>
      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <span class="close-button" @click="showModal = false">&times;</span>
          <p>{{ modalMessage }}</p>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
    data() {
      return {
        loginForm: {
          username: '',
          password: '',
        },
        showModal: false,
        modalMessage: '',
      };
    },
    methods: {
      async onSubmit() {
        try {
          
          console.log('send form', this.loginForm);
          const response = await axios.post('http://43.128.4.99:8080/login', this.loginForm);
          // 登录成功
          console.log(response.data.message);
          this.modalMessage = response.data.message; // 设置成功消息
          this.showModal = true; // 显示模态框
          //这里可以添加更多的逻辑，比如路由跳转等
          this.$router.push({
            name: 'UserProfile',
            params: {
                userName: response.data.userName,
                beersRemaining: "50"
            }
          });
        } catch (error) {
          // 处理错误，比如显示错误消息
          if (error.response) {
            // 请求已发出，但服务器用状态码响应in
            // 超出了2xx的范围
            this.modalMessage = error.response.data.message; // 设置失败消息
          } else {
            // 在设置请求时发生了一些事情，触发了一个错误
            this.modalMessage = '登录过程中发生错误，请稍后重试。'; // 设置通用错误消息
          }
          this.showModal = true; 
        }
      },
    },
  };
  </script>
  
  <style scoped>
  .login-container {
    max-width: 400px;
    margin: 0 auto;
    padding: 20px;
    background-image: url('../src/assets/6d76148633391e1056c435eac19a094b.png'); 
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-color: rgba(255, 255, 255, 0.3); /* 白色背景，透明度调整为0.8 */
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2);
    border-radius: 5px;
  }
  
  
  .logo-container img {
    max-width: 100px; /* 根据需要调整大小 */
    height: auto;
    border-radius: 50%; /* 产生圆形效果 */
    box-shadow: 0 0 10px rgba(0,0,0,1); /* 添加阴影 */
    margin-bottom: 20px;
  }
  
  .logo-container img {
    max-width: 100%;
    height: auto;
  }
  
  .form-group {
    margin-bottom: 15px;
    
  }
  
  .form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: bold; /* 加粗 */
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 1); /* 描边 */
    color: white; /* 设置标签颜色为蓝色 */
    font-size: 18px; /* 将标签字体放大为 18 像素 */
  }
  
  .form-group input[type="text"],
  .form-group input[type="password"] {
    width: 100%;
    padding: 8px 0px;
    line-height: 20px;
    margin: 0 auto; /* 让输入框在父元素中水平居中对齐 */
    margin-bottom: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
  }
  
  .button-container {
    text-align: center;
  }
  .button-container button[type="submit"] {
    font-weight: bold; /* 加粗 */
  }
  button[type="submit"] {
    background-color: #42b983;
    color: white;
    padding: 10px 15px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }
  
  button[type="submit"]:hover {
    background-color: #333;
    
  }
  
  .modal {
    position: fixed;
    z-index: 1;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgba(0, 0, 0, 0.4);
  }
  
  .modal-content {
    background-color: #fefefe;
    margin: 15% auto;
    padding: 20px;
    border: 1px solid #888;
    width: 80%;
  }
  
  .close-button {
    color: #aaa;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  
  .close-button:hover,
  .close-button:focus {
    color: black;
    text-decoration: none;
    cursor: pointer;
  }
  
  /* 响应式设计，适配移动端 */
  @media (max-width: 768px) {
    .login-container {
      width: 90%;
      padding: 10px;
    }
  
    button[type="submit"] {
      width: 100%;
      padding: 12px;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/Home.vue